import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
 import { Container, Row, Col } from "reactstrap";
import "../styles/about.css"
import About from "../components/AboutSection";
 import Testimonials from "../components/Testimonials";
import BookingProcess from "../components/BookingProcess";
 
const AboutPage = () => {
  return (
    <>
    <Meta
      title="About Us"
      
    />
       <div className="about-wrapper">
      <div classname="about__cover-wrapper">
        
      </div>

              <About/>
          <BookingProcess/>
    
      
       
       {/*
         <Testimonials/>
       <div className="members__wrapper">
    
         </div>
         */} 
     
      </div>
    </>
  );
};

export default AboutPage;